import styled, { css } from 'styled-components';

type ToggleSwitchProps = {
  active: boolean;
};

export function ToggleSwitch({ active }: ToggleSwitchProps) {
  return <Slider $active={active} tabIndex={-1} />;
}

const Slider = styled.div<{
  $active: boolean;
}>`
  ${({ theme, $active }) => css`
    position: relative;
    width: 40px;
    height: 20px;
    padding: 2px;
    box-sizing: content-box;
    cursor: pointer;
    border-radius: 34px;
    transition: background-color 0.2s;
    background-color: ${$active
      ? theme.toggleSwitchControl.activeBackgroundColor
      : theme.toggleSwitchControl.backgroundColor};

    &:before {
      content: '';
      position: absolute;
      left: 2px;
      bottom: 2px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: ${theme.toggleSwitchControl.dotColor};
      transition-property: transform;
      transition-duration: inherit;

      ${$active &&
      css`
        transform: translateX(20px);
      `}
    }

    @media (prefers-reduced-motion: reduce) {
      transition: none;

      &:before {
        transition: none;
      }
    }
  `}
`;
